import http from './baseHttp.js'
import util from './util'
// post
var baseRequestData = {
  // 登录
  param_authn_authn_login: {
    // url: '/authn/authn/newLogin',
    url: '/authn/authn/v1/frontLogin',
    param: {
      captchaCode: '', // 图形验证码
      captchaId: '', // 验证码序列号
      loginAccount: '', // 登录账号
      marketId: 3, // 市场id
      terminalType: 4, // 终端类型
      type: '', // 登录方式 1 ：账号密码登录 2 短信验证码登录
      // code: '', // 短信/邮箱验证码 false
      password: '', // 密码 false
      loginWay: 1 // 账号类型(1:手机号 2:邮箱 3:交易账号)
    }
  },
  // 短信登录
  param_authn_authn_codeLogin: {
    // url: '/authn/authn/newLogin',
    url: '/authn/authn/v1/frontSimpleLoginForVerificationCode',
    param: {
      loginWay: 1, // 账号类型(1:手机号 2:邮箱)
      captchaCode: '', // 图形验证码
      captchaId: '', // 验证码序列号
      loginAccount: '', // 登录账号
      terminalType: 4, // 终端类型
      code: '' // 短信/邮箱验证码 false
    }
  },
  // 注册(弃用)
  param_adminRegister: {
    url: '/authn/authn/adminRegister',
    param: {
      captchaCode: '', // 图形验证码
      captchaId: '', // 验证码序列号
      inviteCode: '', // 邀请码
      loginAccount: '', // 登录账号
      marketId: 3, // 市场id
      code: '', // 短信/邮箱验证码 false
      password: '' // 密码 false
    }
  },
  // // 注册  // TODO接口变更 2021-11-25
  // param_registerCustomer: {
  //   url: '/register/register/registerCustomer',
  //   param: {
  //     code: '', // 短信验证码
  //     createWay: 2, // 开户通道（1:管理后台 2:网上开户）
  //     firmTypeId: 1, // 用户类型 （1:交易员 9:交易所）
  //     lnvitationCode: '', // 邀请码
  //     loginAccount: '', // 登录账号
  //     marketId: 3, // 市场id
  //     password: '', // 密码
  //     registerWay: 1, // 注册方式 （1:手机号注册 2:邮箱注册）
  //     // firstMember: true,
  //     lnvitationCodeMustFillIn: true
  //     // messageAuthentication: true,
  //     // userCode: '',//客户编码
  //     // userName: ''//客户名称
  //   }
  // },
  // 注册 接口变更 2021-11-25
  param_registerCustomer: {
    url: '/register/register/v1/addFrontUser',
    param: {
      registerWay: 1, // 注册方式 （1:手机号注册 2:邮箱注册）
      loginAccount: '', // 登录账号
      marketId: 3, // 市场id
      lnvitationCode: '', // 邀请码
      code: '', // 短信验证码
      password: '' // 密码
      // createWay: 2, // 开户通道（1:管理后台 2:网上开户）
      // firmTypeId: 1, // 用户类型 （1:交易员 9:交易所）
      // firstMember: true,
      // lnvitationCodeMustFillIn: true
      // messageAuthentication: true,
      // userCode: '',//客户编码
      // userName: ''//客户名称
    }
  },
  // // 基础服务校验短信新 注册接口 // TODO 注册接口变更 取融合接口
  // param_registerCustomer: {
  //   url: '/register/register/v1/addRareFrontSimpleUser', // (新 不传市场id)(默认创建0市场)
  //   param: {
  //     templateId: 53,
  //     code: '', // 短信验证码
  //     createWay: 2, // 开户通道（1:管理后台 2:网上开户）
  //     firmTypeId: 1, // 用户类型 （1:交易员 9:交易所）
  //     lnvitationCode: '', // 邀请码
  //     loginAccount: '', // 登录账号
  //     marketId: 0, // 市场id (新增)
  //     password: '', // 密码
  //     registerWay: 1, // 注册方式 （1:手机号注册 2:邮箱注册）
  //     // firstMember: true,// 管理后台用
  //     lnvitationCodeMustFillIn: true, // 是否校验邀请码
  //     messageAuthentication: true, // 是否校验短信验证码
  //     // userCode: '',//客户编码
  //     userName: '' // 客户名称
  //   }
  // },
  // 登出
  param_logout: {
    // url: '/authn/authn/logout',
    url: '/authn/authn/v1/logout',
    param: {
      // sessionStr: '' //header
    }
  },
  // 通过用户ID登出
  param_logoutByUserId: {
    url: '/authn/authn/logoutByUserId',
    param: {
      firmId: ''
    }
  },
  // 查询密码是否设置
  param_queryPwdIsSetup: {
    url: '/authn/authn/queryPwdIsSetup',
    param: {
      loginAccount: '' // 登录账号
    }
  },
  // 校验图形验证码
  param_sessionValidCaptcha: {
    url: '/authn/authn/sessionValidCaptcha',
    param: {
      captchaCode: '',
      captchaId: ''
    }
  },
  // 设置密码
  param_setUpPwd: {
    url: '/authn/authn/setUpPwd',
    param: {
      loginAccount: '', // 登录账号
      password: '' // 密码
    }
  },
  // 修改登录密码
  param_simpleFrontUpdatePwdInFlow: {
    url: '/authn/authn/v1/simpleFrontUpdatePwdInFlow',
    param: {
      loginAccount: '', // 用户名
      oldPassword: '', // 旧密码
      password: '' // 新密码
    }
  },
  // 修改密码
  param_updatePwdByOld: {
    // url: '/authn/authn/updatePwdByOld',
    url: '/authn/authn/v1/frontUpdatePwd',
    param: {
      // loginAccount: '', // 用户名
      oldPassword: '', // 旧密码
      password: '', // 新密码
      templateId: 49
    }
  },
  // 忘记密码
  param_updateUserPassword: {
    // url: '/authn/authn/updateUserPassword',
    // url: '/tq-marketing-system/frontUserMaintainController/updateUserPassword',
    url: '/authn/authn/v1/frontForgetPwd',
    param: {
      checkWay: 1,
      templateId: 49,
      captchaCode: '', // 图形验证码
      captchaId: '', // 验证码序列号
      code: '', // 短信/邮箱验证码
      loginAccount: '', // 用户名
      password: '' // 新密码
    }
  },
  // 重置登录密码
  param_simpleFrontForgetPwd: {
    // url: '/authn/authn/updateUserPassword',
    url: '/authn/authn/v1/simpleFrontForgetPwd',
    param: {
      captchaCode: '', // 图形验证码
      captchaId: '', // 验证码序列号
      code: '', // 短信/邮箱验证码
      loginAccount: '', // 用户名
      password: '', // 新密码
      checkWay: 1
    }
  },
  // 发送短信验证码
  param_sendCaptcha: {
    url: '/authn/authn/sendCaptcha',
    param: {
      // firmId: '', // 用户id false
      id: '', // 短信模板编码id  // 2用户注册 38忘记密码 45重置密码 46手机验证码登录 47修改密码 50登录成功 51国商重置密码失败 52国商重置资金密码 100国商重置资金密码失败 101修改资金密码 35开户驳回 28开户通过
      loginAccount: '' //	账号
    }
  },
  // 重置资金密码发送短信
  param_sendSignMsg: {
    url: '/tea-shop-desk/securitySetting/sendSignMsg',
    param: {
      id: '', // 短信模板编码id  // 2用户注册 38忘记密码 45重置密码 46手机验证码登录 47修改密码 50登录成功 51国商重置密码失败 52国商重置资金密码 100国商重置资金密码失败 101修改资金密码 35开户驳回 28开户通过
      cellphone: '' //	账号
    }
  },
  // 修改手机号发送短信
  param_updateCellphoneSendMsg: {
    url: '/base-desk-manage/user/updateCellphoneSendMsg',
    param: {
      newCellphone: '' //	账号
    }
  },
  // 更换手机号
  param_updateCellphoneByUserIdNew: {
    url: '/base-desk-manage/user/updateCellphoneByUserIdNew',
    param: {
      newCellphone: '', //	账号
      code: '',
      pwd: ''
    }
  },
  // 校验短信验证码
  param_validCaptchaJson: {
    url: '/authn/authn/validCaptchaJson',
    param: {}
  },
  // 校验图形和短信验证码
  param_validCacheCaptcha: {
    url: '/authn/authn/validCacheCaptcha',
    param: {}
  },
  // 校验验证码
  param_validCaptcha: {
    url: '/authn/authn/validCaptcha',
    param: {
      captchaId: '', // 验证码序列号
      code: '' // 验证码
    }
  },
  // 校验短信验证码
  param_validMessageCaptcha: {
    url: '/authn/authn/validMessageCaptcha',
    param: {}
  },
  // 查询审核信息
  param_findBaseUserAuditByUserId: {
    // url: '/base-desk-query/baseUserAudit/findBaseUserAuditByUserId',
    url: '/base-desk-query/baseUserAudit/v1/getBaseUserAudit',
    param: {}
  },
  // 新增个人(企业)开户审核
  param_saveBaseUserAudit: {
    url: '/base-desk-manage/baseUserAudit/saveBaseUserAudit',
    param: {
      auditStatus: 0, // 审核状态（0:未审核 1:已认证 2:已驳回）
      auditType: '', // 认证类型（O:组织认证 P:个人认证）
      cellphone: '', // 手机号
      createTime: 0, // 创建时间
      delFlag: true, // 删除标记（0:未删除 1:已删除）
      note: '', // 备注信息
      orgCertCode: '', // 组织证件代码
      orgCertImg: '', // 组织证件照片
      orgCertType: 0, // 组织证件类型（1:社会统一代码）
      orgName: '', // 组织名称
      passTime: 0, // 通过时间
      payTime: 0, // 申请时间
      personCartFrontImg: '', // 证件正面照片
      personCartNegativeImg: '', // 证件反面照片
      personCertNo: '', //	个人证件号码
      personCertType: 0, // 个人证件类型（1:身份证）
      personName: '', // 个人姓名（个人、法人）
      updateTime: 0, // 更新时间
      urgencyContact: '', // 紧急联系人
      urgencyContactAddress: '', // 紧急联系人地址
      urgencyContactPhone: '', // 紧急联系人手机号
      userId: 0 // 客户id（唯一标识）
    }
  },
  // 新增个人开户审核
  param_saveBaseUserAudit_user: {
    // url: '/base-desk-manage/baseUserAudit/saveBaseUserAudit',
    url:
      '/base-desk-manage/baseUserAudit/v1/addOrUpdateBaseUserAuditForNaturalPerson',
    param: {
      // "auditStatus": 0,//审核状态（0:未审核 1:已认证 2:已驳回）
      auditType: '', // 认证类型（O:组织认证 P:个人认证）
      // "cellphone": "",//手机号
      // "createTime": 0,//创建时间
      // "delFlag": true,//删除标记（0:未删除 1:已删除）
      // "note": "",//备注信息
      // "orgCertCode": "",//组织证件代码
      // "orgCertImg": "",//组织证件照片
      // "orgCertType": 0,//组织证件类型（1:社会统一代码）
      // "orgName": "",//组织名称
      // "passTime": 0,//通过时间
      // "payTime": 0,//申请时间
      personCartFrontImg: '', // 证件正面照片
      personCartNegativeImg: '', // 证件反面照片
      personCertNo: '', //	个人证件号码
      personCertType: 0, // 个人证件类型（1:身份证）
      personName: '', // 个人姓名（个人、法人）
      // "updateTime": 0,//更新时间
      urgencyContact: '', // 紧急联系人
      urgencyContactAddress: '', // 紧急联系人地址
      urgencyContactPhone: '' // 紧急联系人手机号
      // "userId": 0//客户id（唯一标识）
    }
  },
  param_saveBaseUserAudit_companys: {
    url:
      '/base-desk-manage/baseUserAudit/v1/addOrUpdateBaseUserAuditForLegalPerson',
    param: {}
  },
  // 新增企业开户审核
  param_saveBaseUserAudit_company: {
    url: '/base-desk-manage/baseUserAudit/saveBaseUserAudit',
    param: {
      // "auditStatus": 0,//审核状态（0:未审核 1:已认证 2:已驳回）
      auditType: '', // 认证类型（O:组织认证 P:个人认证）
      // "cellphone": "",//手机号
      // "createTime": 0,//创建时间
      // "delFlag": true,//删除标记（0:未删除 1:已删除）
      // "note": "",//备注信息
      orgCertCode: '', // 组织证件代码
      orgCertImg: '', // 组织证件照片
      orgCertType: 0, // 组织证件类型（1:社会统一代码）
      orgName: '', // 组织名称
      // "passTime": 0,//通过时间
      // "payTime": 0,//申请时间
      personCartFrontImg: '', // 证件正面照片
      personCartNegativeImg: '', // 证件反面照片
      personCertNo: '', //	个人证件号码
      personCertType: 0, // 个人证件类型（1:身份证）
      personName: '', // 个人姓名（个人、法人）
      // "updateTime": 0,//更新时间
      urgencyContact: '', // 紧急联系人
      urgencyContactAddress: '', // 紧急联系人地址
      urgencyContactPhone: '' // 紧急联系人手机号
      // "userId": 0//客户id（唯一标识）
    }
  },
  // 更换手机号qz
  param_forceUpdateCellphoneByUserId: {
    url: '/base-desk-manage/user/forceUpdateCellphoneByUserId',
    param: {
      newCellphone: '', //	账号
      code: '',
      pwd: ''
    }
  },
  // 新增收货地址
  param_saveUserAddress: {
    url: '/base-address/address/saveUserAddress',
    param: {
      addressName: '', // 收货地址
      defaultFlag: 0, // 是否设置为默认收获地址 (0:否 1:是)
      postCode: '', // 邮政编码
      recipients: '', // 收货人
      recipientsCellphone: '', //	收货人电话
      region: '' // 地区(前端维护辅助字段)
    }
  },
  // 编辑收获地址
  param_updateUserAddress: {
    url: '/base-address/address/updateUserAddress',
    param: {
      addressName: '', // 收货地址
      defaultFlag: 0, // 是否设置为默认收获地址 (0:否 1:是)
      postCode: '', // 邮政编码
      recipients: '', // 收货人
      recipientsCellphone: '', //	收货人电话
      region: '' // 地区(前端维护辅助字段)
    }
  },
  // 删除收货地址
  param_deleteUserAddress: {
    url: '/base-address/address/deleteUserAddress',
    param: {
      addressId: null // 收货地址表主键
    }
  },
  // 编辑收获地址
  param_getUserAddress: {
    url: '/base-address/address/getUserAddress',
    param: {
      // addressId: null, // 收货地址表主键 false
      // defaultFlag: 0, // 是否设置为默认收获地址 (0:否 1:是) false
    }
  }
}

// get
var baseRequestDataGet = {
  // 校验session-header中传参
  param_authorizeSession: {
    url: '/authn/authn/authorizeSession',
    param: {
      firmId: '',
      sessionStr: ''
    }
  },
  // 校验session
  param_authorizeSession1: {
    url: '/authn/authn/authorizeSession1',
    param: {
      firmId: '',
      sessionStr: ''
    }
  },
  // 获取图形验证码
  param_generateCaptcha: {
    url: '/authn/authn/generateCaptcha',
    param: {}
  }
}

const BaseApi = {
  /**
   * 通用登录请求
   * username 用户名
   * md5password 加密密码
   * verificationCode 验证码
   * verificationCodeId 验证码
   * marketId 市场
   * type 登录方式 1 ：账号密码登录 2 短信验证码登录
   * code: '', // 短信/邮箱验证码 false
   * password: '' // 密码 false
   */
  login(loginValue) {
    // const u = navigator.userAgent
    // const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    // 1：Windows PC 客户端2：iOS 客户端3：android 客户端4：window Web端5：交易所管理后台
    // if (isiOS) {
    baseRequestData.param_authn_authn_login.param.terminalType = localStorage.getItem('equipmentFlag_PC') || 4
    // } else {
    //   baseRequestData.param_authn_authn_login.param.terminalType = '3'
    // }
    baseRequestData.param_authn_authn_login.param.loginAccount =
      loginValue.loginAccount
    baseRequestData.param_authn_authn_login.param.loginWay =
      loginValue.loginWay
    baseRequestData.param_authn_authn_login.param.captchaCode =
      loginValue.captchaCode
    baseRequestData.param_authn_authn_login.param.captchaId =
      loginValue.captchaId
    baseRequestData.param_authn_authn_login.param.marketId =
      loginValue.marketId || 3
    baseRequestData.param_authn_authn_login.param.type = 1
    if (loginValue.code) {
      baseRequestData.param_authn_authn_login.param.code = loginValue.code
    }
    baseRequestData.param_authn_authn_login.param.password = util.getmd5(
      '47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + loginValue.password
    )

    return http.postFront(baseRequestData.param_authn_authn_login)
  },
  forceUpdateCellphoneByUserId(sendValue) {
    baseRequestData.param_forceUpdateCellphoneByUserId.param.newCellphone = sendValue.newCellphone
    baseRequestData.param_forceUpdateCellphoneByUserId.param.code = sendValue.code
    baseRequestData.param_forceUpdateCellphoneByUserId.param.pwd = ''
    // baseRequestData.param_updateCellphoneByUserIdNew.param.pwd = util.getmd5('47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + sendValue.password)

    return http.postFront(baseRequestData.param_forceUpdateCellphoneByUserId)
  },
  codeLogin(loginValue) {
    // const u = navigator.userAgent
    // const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    // 1：Windows PC 客户端2：iOS 客户端3：android 客户端4：window Web端5：交易所管理后台
    // if (isiOS) {
    baseRequestData.param_authn_authn_codeLogin.param.terminalType = localStorage.getItem('equipmentFlag_PC') || 4
    // } else {
    //   baseRequestData.param_authn_authn_codeLogin.param.terminalType = '3'
    // }
    baseRequestData.param_authn_authn_codeLogin.param.loginAccount =
      loginValue.loginAccount
    baseRequestData.param_authn_authn_codeLogin.param.captchaCode =
      loginValue.captchaCode
    baseRequestData.param_authn_authn_codeLogin.param.captchaId =
      loginValue.captchaId
    baseRequestData.param_authn_authn_codeLogin.param.code = loginValue.code
    baseRequestData.param_authn_authn_codeLogin.param.marketId = loginValue.marketId || 3
    // baseRequestData.param_authn_authn_codeLogin.param.type = 1
    return http.postFront(baseRequestData.param_authn_authn_codeLogin)
  },
  /**
   * 注册 (弃用)
   * captchaCode: '', //图形验证码
   * captchaId: '', //验证码序列号
   * inviteCode: '', //邀请码
   * loginAccount: '', //登录账号
   * marketId: 3, //市场id
   * code: '', //短信/邮箱验证码 false
   * password: '', //密码 false
   */
  adminRegister(registerValue) {
    baseRequestData.param_adminRegister.param.captchaCode =
      registerValue.captchaCode
    baseRequestData.param_adminRegister.param.captchaId =
      registerValue.captchaId
    baseRequestData.param_adminRegister.param.inviteCode =
      registerValue.inviteCode
    baseRequestData.param_adminRegister.param.loginAccount =
      registerValue.loginAccount
    baseRequestData.param_adminRegister.param.marketId =
      registerValue.marketId || 3
    baseRequestData.param_adminRegister.param.code = registerValue.code
    baseRequestData.param_adminRegister.param.password = util.getmd5(
      '47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + registerValue.password
    )

    return http.postFront(baseRequestData.param_adminRegister)
  },
  /**
   * 注册
   * code: '',//短信验证码
   * createWay: 2,//开户通道（1:管理后台 2:网上开户）
   * firmTypeId: 1,//用户类型 （1:交易员 9:交易所）
   * lnvitationCode: '',//邀请码
   * loginAccount: '',//登录账号
   * marketId: 3,//市场id
   * password: '',//密码
   * registerWay: 1,//注册方式 （1:手机号注册 2:邮箱注册）
   * // firstMember: true,
   * // lnvitationCodeMustFillIn: true,
   * // messageAuthentication: true,
   * // userCode: '',//客户编码
   * // userName: ''//客户名称
   */
  registerCustomer(registerValue) {
    baseRequestData.param_registerCustomer.param.code = registerValue.code
    baseRequestData.param_registerCustomer.param.createWay = 2
    baseRequestData.param_registerCustomer.param.firmTypeId = 1
    baseRequestData.param_registerCustomer.param.registerWay = 1
    baseRequestData.param_registerCustomer.param.lnvitationCode =
      registerValue.lnvitationCode // 邀请码
    baseRequestData.param_registerCustomer.param.loginAccount =
      registerValue.loginAccount
    baseRequestData.param_registerCustomer.param.marketId =
      registerValue.marketId || 3
    baseRequestData.param_registerCustomer.param.password = util.getmd5(
      '47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + registerValue.password
    )

    return http.postFront(baseRequestData.param_registerCustomer)
  },
  /**
   * 登出
   */
  logout() {
    return http.postFront(baseRequestData.param_logout)
  },
  /**
   * 通过用户ID登出 (管理后台)
   * firmId 用户id
   */
  logoutByUserId(firmId) {
    baseRequestData.param_logoutByUserId.param.captchaCode = firmId

    return http.postFront(baseRequestData.param_logoutByUserId)
  },
  /**
   * 查询密码是否设置
   * loginAccount 登录账号
   */
  queryPwdIsSetup(loginAccount) {
    baseRequestData.param_queryPwdIsSetup.param.loginAccount = loginAccount

    return http.postFront(baseRequestData.param_queryPwdIsSetup)
  },
  /**
   * 发送短信验证码
   * firmId:'', //用户id false
   * id:'', // 短信模板编码id
   * loginAccount:'' //	账号
   */
  sendCaptcha(sendValue) {
    // baseRequestData.param_sendCaptcha.param.firmId = firmId
    baseRequestData.param_sendCaptcha.param.id = sendValue.id
    baseRequestData.param_sendCaptcha.param.loginAccount =
      sendValue.loginAccount
    baseRequestData.param_sendCaptcha.param.code =
      sendValue.code
    return http.postFront(baseRequestData.param_sendCaptcha)
  },
  /**
   * 发送短信验证码
   * firmId:'', //用户id false
   * id:'', // 短信模板编码id
   * loginAccount:'' //	账号
   */
  sendSignMsg(sendValue) {
    // baseRequestData.param_sendCaptcha.param.firmId = firmId
    baseRequestData.param_sendSignMsg.param.id = sendValue.id
    baseRequestData.param_sendSignMsg.param.cellphone =
      sendValue.cellphone

    return http.postFront(baseRequestData.param_sendSignMsg)
  },
  /**
   * 校验图形验证码
   * captchaCode:'',
   * captchaId:''
   */
  sessionValidCaptcha(sendValue) {
    baseRequestData.param_sessionValidCaptcha.param.captchaCode =
      sendValue.captchaCode
    baseRequestData.param_sessionValidCaptcha.param.captchaId =
      sendValue.captchaId

    return http.postFront(baseRequestData.param_sessionValidCaptcha)
  },
  /**
   * 设置密码
   * loginAccount:'',//登录账号
   * password:''//密码
   */
  setUpPwd(sendValue) {
    baseRequestData.param_setUpPwd.param.loginAccount = sendValue.loginAccount
    baseRequestData.param_setUpPwd.param.password = util.getmd5(
      '47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + sendValue.password
    )

    return http.postFront(baseRequestData.param_setUpPwd)
  },
  /**
   * 修改密码
   * loginAccount:'',//用户名
   * oldPassword:'', //旧密码
   * password:''     //新密码
   */
  updatePwdByOld(sendValue) {
    baseRequestData.param_updatePwdByOld.param.loginAccount =
      sendValue.loginAccount
    baseRequestData.param_updatePwdByOld.param.oldPassword = util.getmd5(
      '47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + sendValue.oldPassword
    )
    baseRequestData.param_updatePwdByOld.param.password = util.getmd5(
      '47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + sendValue.password
    )

    return http.postFront(baseRequestData.param_updatePwdByOld)
  },
  // 修改登录密码
  simpleFrontUpdatePwdInFlow(sendValue) {
    baseRequestData.param_simpleFrontUpdatePwdInFlow.param.loginAccount = sendValue.loginAccount
    baseRequestData.param_simpleFrontUpdatePwdInFlow.param.oldPassword = util.getmd5('47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + sendValue.oldPassword)
    baseRequestData.param_simpleFrontUpdatePwdInFlow.param.password = util.getmd5('47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + sendValue.password)

    return http.postFront(baseRequestData.param_simpleFrontUpdatePwdInFlow)
  },
  /**
   * 忘记密码
   * captchaCode:'',//图形验证码
   * captchaId:'', //验证码序列号
   * code:'', //短信/邮箱验证码
   * loginAccount:'',// 用户名
   * password:'' //新密码
   */
  updateUserPassword(sendValue) {
    baseRequestData.param_updateUserPassword.param.captchaCode =
      sendValue.captchaCode
    baseRequestData.param_updateUserPassword.param.captchaId =
      sendValue.captchaId
    baseRequestData.param_updateUserPassword.param.code = sendValue.code
    baseRequestData.param_updateUserPassword.param.loginAccount =
      sendValue.loginAccount
    baseRequestData.param_updateUserPassword.param.password = util.getmd5(
      '47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + sendValue.password
    )

    return http.postFront(baseRequestData.param_updateUserPassword)
  },
  simpleFrontForgetPwd(sendValue) {
    baseRequestData.param_simpleFrontForgetPwd.param.captchaCode =
      sendValue.captchaCode
    baseRequestData.param_simpleFrontForgetPwd.param.captchaId =
      sendValue.captchaId
    baseRequestData.param_simpleFrontForgetPwd.param.code = sendValue.code
    baseRequestData.param_simpleFrontForgetPwd.param.loginAccount =
      sendValue.loginAccount
    baseRequestData.param_simpleFrontForgetPwd.param.password = util.getmd5(
      '47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + sendValue.password
    )

    return http.postFront(baseRequestData.param_simpleFrontForgetPwd)
  },
  /**
   * 校验图形和短信验证码
   * TODO: 参数?
   */
  validCacheCaptcha() {
    return http.postFront(baseRequestData.param_validCacheCaptcha)
  },
  /**
   * 校验验证码
   * captchaId:'',//验证码序列号
   * code:''// 验证码
   */
  validCaptcha(sendValue) {
    baseRequestData.param_validCaptcha.param.captchaId = sendValue.captchaId
    baseRequestData.param_validCaptcha.param.code = sendValue.code

    return http.postFront(baseRequestData.param_validCaptcha)
  },
  // 校验短信验证码
  validCaptchaJson(sendValue) {
    baseRequestData.param_validCaptchaJson.param.captchaId = sendValue.captchaId
    baseRequestData.param_validCaptchaJson.param.code = sendValue.code

    return http.postFront(baseRequestData.param_validCaptchaJson)
  },
  /**
   * 校验短信验证码
   */
  validMessageCaptcha() {
    return http.postFront(baseRequestData.param_validMessageCaptcha)
  },
  /**
     * 发送短信验证码
     * firmId:'', //用户id false
     * id:'', // 短信模板编码id
     * loginAccount:'' //	账号
     */
  sendCaptcha(sendValue) {
    // baseRequestData.param_sendCaptcha.param.firmId = firmId
    baseRequestData.param_sendCaptcha.param.id = sendValue.id
    baseRequestData.param_sendCaptcha.param.loginAccount = sendValue.loginAccount
    baseRequestData.param_sendCaptcha.param.code =
    sendValue.code
    return http.postFront(baseRequestData.param_sendCaptcha)
  },
  updateCellphoneSendMsg(sendValue) {
    console.log(sendValue)
    baseRequestData.param_updateCellphoneSendMsg.param.newCellphone = sendValue.newCellphone

    return http.postFront(baseRequestData.param_updateCellphoneSendMsg)
  },
  updateCellphoneByUserIdNew(sendValue) {
    baseRequestData.param_updateCellphoneByUserIdNew.param.newCellphone = sendValue.newCellphone
    baseRequestData.param_updateCellphoneByUserIdNew.param.code = sendValue.code
    baseRequestData.param_updateCellphoneByUserIdNew.param.pwd = util.getmd5('47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + sendValue.password)

    return http.postFront(baseRequestData.param_updateCellphoneByUserIdNew)
  },
  /**
   * 校验session-header中传参
   * firmId:'',
   * sessionStr:''
   */
  authorizeSession(sendValue) {
    baseRequestDataGet.param_authorizeSession.param.firmId = sendValue.firmId
    baseRequestDataGet.param_authorizeSession.param.sessionStr =
      sendValue.sessionStr

    return http.getNewPath2(baseRequestDataGet.param_authorizeSession)
  },
  /**
   * 校验session
   * firmId:'',
   * sessionStr:''
   */
  authorizeSession1(sendValue) {
    baseRequestDataGet.param_authorizeSession1.param.firmId = sendValue.firmId
    baseRequestDataGet.param_authorizeSession1.param.sessionStr =
      sendValue.sessionStr

    return http.getNewPath2(baseRequestDataGet.param_authorizeSession1)
  },
  /**
   * 获取图形验证码
   */
  generateCaptcha() {
    return http.getNewPath2(baseRequestDataGet.param_generateCaptcha)
  },
  /**
   * 上传文件(图片)
   */
  uploadFile(file) {
    return http.postFile(file)
  },
  /**
   * 查询审核信息
   * userId header
   */
  findBaseUserAuditByUserId() {
    return http.postFront(baseRequestData.param_findBaseUserAuditByUserId)
  },
  /**
   * 新增个人开户审核
   * 'auditType': 'P', // 认证类型（O:组织认证 P:个人认证）
   * 'personCartFrontImg': '', // 证件正面照片
   * 'personCartNegativeImg': '', // 证件反面照片
   * 'personCertNo': '', //	个人证件号码
   * 'personCertType': 1, // 个人证件类型（1:身份证）
   * 'personName': '', // 个人姓名（个人、法人）
   * 'urgencyContact': '', // 紧急联系人
   * 'urgencyContactAddress': '', // 紧急联系人地址
   * 'urgencyContactPhone': '' // 紧急联系人手机号
   */
  // 新基础服务(个人认证审核 2021年4月21日13:46:14变更)
  saveBaseUserAudit_user(sendValue) {
    baseRequestData.param_saveBaseUserAudit_user.param = sendValue
    return http.postFront(baseRequestData.param_saveBaseUserAudit_user)
  },
  // 新基础服务(企业认证审核 2021年4月21日13:46:14变更)
  saveBaseUserAudit_users(sendValue) {
    baseRequestData.param_saveBaseUserAudit_companys.param = sendValue
    return http.postFront(baseRequestData.param_saveBaseUserAudit_companys)
  },
  /**
   * 新增企业开户审核
   * 'auditType': 'O', // 认证类型（O:组织认证 P:个人认证）
   * 'orgCertCode': '', // 组织证件代码
   * 'orgCertImg': '', // 组织证件照片
   * 'orgCertType': 1, // 组织证件类型（1:社会统一代码）
   * 'orgName': '', // 组织名称
   * 'personCartFrontImg': '', // 证件正面照片
   * 'personCartNegativeImg': '', // 证件反面照片
   * 'personCertNo': '', //	个人证件号码
   * 'personCertType': 1, // 个人证件类型（1:身份证）
   * 'personName': '', // 个人姓名（个人、法人）
   * 'urgencyContact': '', // 紧急联系人
   * 'urgencyContactAddress': '', // 紧急联系人地址
   * 'urgencyContactPhone': '' // 紧急联系人手机号
   */
  saveBaseUserAudit_company(sendValue) {
    baseRequestData.param_saveBaseUserAudit_company.param = sendValue
    return http.postFront(baseRequestData.param_saveBaseUserAudit_company)
  },
  /**
   * 新增收货地址
   * 'addressName': '', // 收货地址
   * 'defaultFlag': 0, // 是否设置为默认收获地址 (0:否 1:是)
   * 'postCode': '', // 邮政编码
   * 'recipients': '', // 收货人
   * 'recipientsCellphone': '', //	收货人电话
   * 'region': '' // 地区(前端维护辅助字段)
   */
  saveUserAddress(sendValue) {
    baseRequestData.param_saveUserAddress.param = sendValue
    return http.postFront(baseRequestData.param_saveUserAddress)
  },
  /**
   * 修改收货地址
   * 'addressId'
   * 'addressName': '', // 收货地址
   * 'defaultFlag': 0, // 是否设置为默认收获地址 (0:否 1:是)
   * 'postCode': '', // 邮政编码
   * 'recipients': '', // 收货人
   * 'recipientsCellphone': '', //	收货人电话
   * 'region': '' // 地区(前端维护辅助字段)
   */
  updateUserAddress(sendValue) {
    baseRequestData.param_updateUserAddress.param = sendValue
    return http.postFront(baseRequestData.param_updateUserAddress)
  },
  /**
   * 删除收货地址
   * addressId: null, // 收货地址表主键
   */
  deleteUserAddress(sendValue) {
    baseRequestData.param_deleteUserAddress.param = sendValue
    return http.postFront(baseRequestData.param_deleteUserAddress)
  },
  /**
   * 查询收货地址
   *  addressId: null, // 收货地址表主键 false
   *  defaultFlag: 0, // 是否设置为默认收获地址 (0:否 1:是) false
   */
  getUserAddress(sendValue) {
    baseRequestData.param_getUserAddress.param = sendValue || {}
    return http.postFront(baseRequestData.param_getUserAddress)
  },
  // 查询默认收货地址
  getDefaultAddress() {
    const sendValue = {
      defaultFlag: 1
    }
    baseRequestData.param_getUserAddress.param = sendValue
    return http.postFront(baseRequestData.param_getUserAddress)
  },
  // 根据id查询地址详情
  getUserAddressWithId(id) {
    const sendValue = {
      addressId: id
    }
    baseRequestData.param_getUserAddress.param = sendValue
    return http.postFront(baseRequestData.param_getUserAddress)
  }
}

export default BaseApi
